import React from "react";
import s from "../style.module.css";

export default function LitleScreen({
  contentPaulSab,
  contentN7,
  contentAirfrance,
  contentOrange,
  contentAirbus,
  contentDevhop,
  contentKoncept,
  icon,
  isSmallScreen,
  sectionLitleScreen,
}) {
  return (
    <>
      <div className="row">
        {sectionLitleScreen(
          isSmallScreen ? "Expériences pro" : "Expériences professionnelles",
          "worker"
        )}
      </div>
      <div className="row">
        {icon("devhop.webp", false, false)}
        <div
          className={`${s.text} ps-3 pe-2 col-9 col-sm-8 col-md-10 d-flex align-items-start justify-content-start`}
        >
          {contentDevhop()}
        </div>
      </div>
      <div className="row">
        {icon("airfrance.webp", false, false)}
        <div
          className={`${s.text} ps-3 pe-2 col-9 col-sm-8 col-md-10 d-flex align-items-start justify-content-start`}
        >
          {contentAirfrance()}
        </div>
      </div>
      <div className="row">
        {icon("airbus.webp", false, false)}
        <div
          className={`${s.text} ps-3 pe-2 col-9 col-sm-8 col-md-10 d-flex align-items-start justify-content-start`}
        >
          {contentAirbus()}
        </div>
      </div>
      <div className="row">
        {icon("koncept.jpeg", false, false)}
        <div
          className={`${s.text} ps-3 pe-2 col-9 col-sm-8 col-md-10 d-flex align-items-start justify-content-start`}
        >
          {contentKoncept()}
        </div>
      </div>
      <div className="row">
        {icon("orange.webp", false, false)}
        <div
          className={`${s.text} ps-3 pe-2 col-9 col-sm-8 col-md-10 d-flex align-items-start justify-content-start`}
        >
          {contentOrange()}
        </div>
      </div>
      <div className="row">{sectionLitleScreen("Formations", "student")}</div>
      <div className="row">
        {icon("enseeiht.webp", false, false)}
        <div
          className={`${s.text} ps-3 pe-2 pt-1 col-9 col-sm-8 col-md-10 d-flex align-items-start justify-content-start`}
        >
          {contentN7()}
        </div>
      </div>
      <div className="row">
        {icon("paulsab.webp", false, true)}
        <div
          className={`${s.text} ps-3 pe-2 pt-1 col-9 col-sm-8 col-md-10 d-flex align-items-start justify-content-start`}
        >
          {contentPaulSab()}
        </div>
      </div>
      <div className="row">
        {sectionLitleScreen("Rejoignez l'aventure !", "end")}
      </div>
    </>
  );
}
